(function () {
  const CDN_SRC = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.0/dist/confetti.browser.min.js';
  let loadPromise = null;

  function ensureConfettiLib () {
    if (typeof window === 'undefined') {
      return Promise.reject(new Error('Confetti unavailable'));
    }

    if (window.confetti) {
      return Promise.resolve(window.confetti);
    }

    if (!loadPromise) {
      loadPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = CDN_SRC;
        script.async = true;
        script.onload = () => resolve(window.confetti);
        script.onerror = () => {
          loadPromise = null;
          reject(new Error('Failed to load confetti library'));
        };
        document.head.appendChild(script);
      });
    }

    return loadPromise;
  }

  function runBurst (origin) {
    if (!window.confetti) {
      return;
    }

    const count = 200;
    const defaults = {
      origin
    };

    function fire (particleRatio, opts) {
      window.confetti({
        ...defaults,
        ...opts,
        particleCount: Math.floor(count * particleRatio)
      });
    }

    fire(0.25, {
      spread: 26,
      startVelocity: 55
    });
    fire(0.2, {
      spread: 60
    });
    fire(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8
    });
    fire(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2
    });
    fire(0.1, {
      spread: 120,
      startVelocity: 45
    });
  }

  function fireFromElement (element) {
    if (!element || typeof element.getBoundingClientRect !== 'function') {
      return;
    }

    ensureConfettiLib()
      .then(() => {
        const rect = element.getBoundingClientRect();
        const origin = {
          x: (rect.left + rect.width / 2) / window.innerWidth,
          y: (rect.top + rect.height / 2) / window.innerHeight
        };
        runBurst(origin);
      })
      .catch(() => {
        // Silently ignore load errors
      });
  }

  window.SootheConfetti = {
    fireFromElement
  };
})();
